import React from 'react'
import { Query } from 'react-apollo'

import getNearbyRestaurants from './SearchResults.graphql'
import variables from './fixtures/SearchResults.json'
import Progress from '../Progress/Progress'
import Error from '../Error/Error'

import './SearchResults.css'

const SearchResults = () => {
  return (
    <React.Fragment>
      <h2>Restaurant list</h2>
      <Query query={getNearbyRestaurants} variables={variables}>
        {({ loading, error, data }) => {
          if (loading) return <Progress eventData={{ category: 'Search Results' }} />
          if (error) return <Error error={error} />
          // We need to explicitly bypass react-router since the shortUrl is
          // part of the basename now and to ensure OO_GLOBALS gets reloaded
          // correctly.
          const restaurants = data.nearbyRestaurants.filter(({ shortUrl }) => Boolean(shortUrl))

          return (
            <table styleName='table'>
              <thead>
                <tr>
                  <td>Restaurant ({restaurants.length})</td>
                  <td colSpan='3'>Environment</td>
                </tr>
              </thead>
              <tbody>
                {restaurants.map(({ name, shortUrl, guid }) => (
                  <tr key={shortUrl}>
                    <td>
                      {name}
                    </td>
                    <td>
                      <a href={`/${shortUrl}/v3`}>local dev</a>
                    </td>
                    <td>
                      <a href={`https://preprod.eng.toasttab.com/${shortUrl}/v3?overrideV3Enabled=true`}>preprod</a>
                    </td>
                    <td>
                      <a href={`https://www.toasttab.com/${shortUrl}/v3?overrideV3Enabled=true`}>prod</a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        }}
      </Query>
    </React.Fragment>
  )
}

export default SearchResults
